module.exports = __webpack_public_path__ + "static/media/minilogo.ee67df46.jpg";